import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Paper } from "@mui/material";
import Questions from "./Questions";
import WorkLog from "../ProjectActivity/WorkLog";
import CorpusDisbursements from "./CorpusDisbursements";
import ActivityTimeline from "./ActivityTimeline";
import { ProjectContext } from "../../../AppContext/ProjectContext";
import {
  ChatBubbleOutline,
  Assessment,
  AccountBalance,
  Timeline,
} from "@mui/icons-material";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`issue-tabpanel-${index}`}
      aria-labelledby={`issue-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const BASE_TABS = [
  { label: "Comments", icon: <ChatBubbleOutline fontSize="small" />, key: "qa" },
  { label: "Work Log", icon: <Assessment fontSize="small" />, key: "report" },
  { label: "Activity", icon: <Timeline fontSize="small" />, key: "activity" },
];

const CORPUS_TAB = { label: "Disbursements", icon: <AccountBalance fontSize="small" />, key: "disbursements" };

export default function ProjectActivity({ corpusDisbursements = [] }) {
  const [value, setValue] = React.useState(0);
  const { projectInfo } = React.useContext(ProjectContext);

  const isCorpus = projectInfo?.projectType === "corpus";
  const isFundRaise = projectInfo?.projectType === "fund-raise";

  // Add Disbursements tab for corpus & fund-raise projects
  const tabs = React.useMemo(() => {
    if (!isCorpus && !isFundRaise) return BASE_TABS;
    return [...BASE_TABS, CORPUS_TAB];
  }, [isCorpus, isFundRaise]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const renderTabContent = (tab) => {
    switch (tab.key) {
      case "qa":
        return <Questions />;
      case "disbursements":
        return <CorpusDisbursements disbursements={corpusDisbursements} />;
      case "report":
        return <WorkLog />;
      case "activity":
        return <ActivityTimeline />;
      default:
        return null;
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{ borderRadius: 3, border: "1px solid #e0e0e0", overflow: "hidden" }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#fafafa" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              minHeight: 48,
            },
          }}
        >
          {tabs.map((tab, i) => (
            <Tab
              key={tab.key}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, i) => (
        <CustomTabPanel key={tab.key} value={value} index={i}>
          {renderTabContent(tab, i)}
        </CustomTabPanel>
      ))}
    </Paper>
  );
}
